import { PDFViewer } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import authHeader from "services/auth-header";

import { LossRunReportPdf } from "components/Pdfs/LossRunReport/LossRunReportPdf";
import API from "services/axios";
import { WoCuttingPdf } from "components/Pdfs/WoCuttingPdf/WoCuttingPdf";

const data = [];

const selectedQuote = {};

const selectedReport = {};

// Cutting Pdf
const selectedWO = {
  id: 103,
  woId: 103,
  companyId: 3,
  userId: 5,
  customerId: 102,
  customerName: "test 2",
  jobName: "JOb 31",
  subJobName: null,
  approvalStatus: false,
  approvalLink: "waJ6ND",
  WOStatus: "pending",
  createdBy: "tariq dev",
  locationId: 13,
  WODate: "2023-06-26T00:00:00.000Z",
  WoDueDate: "2023-06-26T00:00:00.000Z",
  WoShipDate: null,
  salesPersonId: 2,
  taxExamption: true,
  taxRateId: 5,
  paymentTermsId: 7,
  isCommission: null,
  shipmentMethod: 1,
  subTotal: null,
  shippingTotal: null,
  grandTotal: null,
  billingAddress:
    '{"addressCompany":null,"addressLine1":null,"addressLine2":null,"city":"sialkot","state":null,"zipCode":"51310","country":"Pakistan"}',
  shippingAddress:
    '{"description":"","addressCompany":"","addressLine1":"Excel address 1","addressLine2":"Excel Address 2","city":"Sialkot","state":"PB","zip":"51310","country":"Pakistan","authorizePerson":"","authorizeLocation":"","serviceId":"","addressType":"","addressDhlTransit":null,"addressGroundTransitDays":null}',
  contactData:
    '{"firstName":"tariq 3","lastName":"tahir","department":"Software Developer","phone":"+9230407554654","email":"tariq.dev43@gmail.com","WoShipDate":"","shipmentMethod":1}',
  notes: "",
  createdAt: "2024-05-09T14:47:32.000Z",
  updatedAt: "2025-12-02T06:16:05.000Z",
  location: {
    name: "Krown Sports",
    logo: "krown-logo.jpg",
    pdfLogo: "kms/companyLogos/3/locationLogo/pdfLogo/krown.png",
  },
  salesPerson: {
    name: "Mohsin",
  },
  paymentTerm: {
    name: "term 1",
  },
  taxrate: {
    name: "NWK",
    number: "123",
    rate: "0.16",
  },
  customer: {
    id: 102,
    customerId: 3,
    customerName: "test 2",
  },
  shippingMethod: {
    name: "DHL",
  },
};

let pdfProducts = [
  {
    approvalColors: [],
    id: 122,
    companyId: 3,
    WOId: 103,
    userId: 5,
    sortId: 1,
    productTypeId: 4,
    productType: "Sublimation",
    productStyle: "JSK-21321",
    productColor: "YELLOW",
    productDescription: "JERSEY",
    productFabric: "asdas",
    productSizes:
      '[{"size":"XS","quantity":"7","price":"3","cost":150.5,"id":"35fbf4c8-033a-4eee-98bd-ed308fa69568","sortId":3},{"size":"S","quantity":"3","price":"3","cost":60,"id":"91a1647c-3e1a-47f9-9a97-5d4821626492","sortId":2},{"size":"M","quantity":"8","price":"3","cost":52,"id":"5c32adf5-ec0a-4b47-905d-30b136ba0a1a","sortId":4},{"size":"l","quantity":"8","price":"3","cost":52,"id":"e9757ae9-f1823-4cb9-948e-e43de00eb592","sortId":7},{"size":"XL","quantity":"8","price":"3","cost":180,"id":"68b3dc7f-bc56-4163-ab3d-bbec6e3b855d","sortId":1}]',
    productUrl: null,
    productImage:
      "kms/wo/103/products/Screenshot 2025-02-17 222342_2025-09-03T16-57-18.png",
    isCommission: null,
    isCommissionType: null,
    isCommissionValue: null,
    isCommissionTotal: null,
    hasName: null,
    hasNumbers: null,
    teamName: null,
    packagedBy: null,
    totalQuantity: 34,
    totalPrice: 102,
    notes: "<p>aasdasd</p>",
    isReady: false,
    lotImagePath: "",
    approveStatus: "pending",
    approvedTime: null,
    approvalComments: "",
    createdAt: "2024-05-09T14:47:32.000Z",
    updatedAt: "2025-12-05T16:45:53.000Z",
    productTypes: {
      id: 6,
      companyId: 3,
      productTypeId: 4,
      sortId: 3,
      productTypes: "Sublimation -nn",
      showOnJobBoard: true,
      createdAt: "2023-03-22T10:00:03.000Z",
      updatedAt: "2025-11-06T16:29:26.000Z",
    },
  },
  {
    approvalColors: [],
    id: 124,
    companyId: 3,
    WOId: 103,
    userId: 5,
    sortId: 2,
    productTypeId: 5,
    productType: "Embroidery",
    productStyle: "Sh-001",
    productColor: "RED",
    productDescription: "SKD-123",
    productFabric: "INTERLOCK-287",
    productSizes:
      '[{"size":"xs","quantity":"8","price":"4","cost":33.6,"id":"a9869dbd-cf3d-4b82-89ac-89c05ae4f025","sortId":1},{"size":"s","quantity":"18","price":"4","cost":75.60000000000001,"id":"5a5398dc-1918-473e-9791-6d2da7371a60","sortId":2},{"size":"m","quantity":"6","price":"4","cost":27,"id":"1b89a15b-3c19-4d43-8aa6-d942ec759ee3","sortId":3},{"size":"l","quantity":"12","price":"4","cost":54,"id":"8566ab17-842a-4f42-89a9-924b28e9707f","sortId":4},{"size":"xl","quantity":"9","price":"4","cost":43.199999999999996,"id":"7425948f-ff30-4dff-957a-d430a1806066","sortId":5}]',
    productUrl: null,
    productImage: "",
    isCommission: null,
    isCommissionType: null,
    isCommissionValue: null,
    isCommissionTotal: null,
    hasName: null,
    hasNumbers: null,
    teamName: null,
    packagedBy: null,
    totalQuantity: 53,
    totalPrice: 212,
    notes: "",
    isReady: false,
    lotImagePath: "",
    approveStatus: "pending",
    approvedTime: null,
    approvalComments: "",
    createdAt: "2024-05-09T14:47:33.000Z",
    updatedAt: "2025-12-02T09:48:58.000Z",
    productTypes: {
      id: 7,
      companyId: 3,
      productTypeId: 5,
      sortId: 6,
      productTypes: "Embroidery",
      showOnJobBoard: true,
      createdAt: "2023-03-22T10:00:26.000Z",
      updatedAt: "2025-06-20T16:01:42.000Z",
    },
  },
  {
    approvalColors: [],
    id: 123,
    companyId: 3,
    WOId: 103,
    userId: 5,
    sortId: 3,
    productTypeId: 1,
    productType: "Screen Printing",
    productStyle: "Sh-Pr-001",
    productColor: "Green",
    productDescription: "Screen-Jersey",
    productFabric: "zsZA",
    productSizes:
      '[{"size":"xs","quantity":"4","price":"5","cost":9.2,"id":"23e5527c-1d21-47b9-b773-8dcc770eab6b","sortId":1},{"size":"s","quantity":"8","price":"5","cost":18.4,"id":"faf14144-b5a6-446d-897b-df5c07630ae9","sortId":2},{"size":"m","quantity":"16","price":"5","cost":51.2,"id":"3499db27-7d6a-4feb-8a52-4b140d8d0424","sortId":3},{"size":"l","quantity":"11","price":"5","cost":35.2,"id":"c5cc4351-847d-4e93-96fb-9575bf62934e","sortId":4},{"size":"xl","quantity":"12","price":"5","cost":45.839999999999996,"id":"60cfc5c4-f4fd-4f97-b785-7799063725f9","sortId":5}]',
    productUrl: null,
    productImage: "",
    isCommission: null,
    isCommissionType: null,
    isCommissionValue: null,
    isCommissionTotal: null,
    hasName: null,
    hasNumbers: null,
    teamName: null,
    packagedBy: null,
    totalQuantity: 51,
    totalPrice: 255,
    notes: "",
    isReady: false,
    lotImagePath: null,
    approveStatus: "pending",
    approvedTime: "2025-11-28",
    approvalComments: null,
    createdAt: "2024-05-09T14:47:33.000Z",
    updatedAt: "2025-11-28T09:48:08.000Z",
    productTypes: {
      id: 3,
      companyId: 3,
      productTypeId: 1,
      sortId: 4,
      productTypes: "Screen Printing",
      showOnJobBoard: true,
      createdAt: "2023-03-22T09:52:34.000Z",
      updatedAt: "2023-03-27T07:33:03.000Z",
    },
  },
  {
    approvalColors: [],
    id: 125,
    companyId: 3,
    WOId: 103,
    userId: 5,
    sortId: 4,
    productTypeId: 3,
    productType: "Digital Print",
    productStyle: "JSK-21321",
    productColor: "Orange",
    productDescription: "Blank-Product",
    productFabric: "f",
    productSizes:
      '[{"size":"xs","quantity":"6","price":"2","cost":19.200000000000003,"id":"8741ae95-2b80-465e-9949-ba9084faebd3","sortId":1},{"size":"s","quantity":"7","price":"2","cost":22.400000000000002,"id":"be5b7b31-e0de-4c29-8afa-6d406b78228d","sortId":2},{"size":"m","quantity":"8","price":"2","cost":30.4,"id":"12ed27ad-89c0-439c-8861-c519715386dc","sortId":3},{"size":"l","quantity":"12","price":"2","cost":45.599999999999994,"id":"f466215f-65f8-4c97-b9a2-6ddd650a4687","sortId":4},{"size":"xl","quantity":"15","price":"2","cost":67.5,"id":"b1947cec-3025-4bc9-b02c-8ef10e4a4f63","sortId":5}]',
    productUrl: null,
    productImage: "",
    isCommission: null,
    isCommissionType: null,
    isCommissionValue: null,
    isCommissionTotal: null,
    hasName: null,
    hasNumbers: null,
    teamName: null,
    packagedBy: null,
    totalQuantity: 48,
    totalPrice: 96,
    notes: "",
    isReady: false,
    lotImagePath: null,
    approveStatus: "pending",
    approvedTime: "2025-11-28",
    approvalComments: null,
    createdAt: "2024-05-09T14:47:34.000Z",
    updatedAt: "2025-11-28T09:48:08.000Z",
    productTypes: {
      id: 5,
      companyId: 3,
      productTypeId: 3,
      sortId: 5,
      productTypes: "Digital Print",
      showOnJobBoard: true,
      createdAt: "2023-03-22T09:59:51.000Z",
      updatedAt: "2025-06-20T16:01:42.000Z",
    },
  },
  {
    approvalColors: [],
    id: 127,
    companyId: 3,
    WOId: 103,
    userId: 5,
    sortId: 5,
    productTypeId: 4,
    productType: "Sublimation",
    productStyle: "T-Shirt",
    productColor: "brown",
    productDescription: "Sub Shirt",
    productFabric: "Lycra",
    productSizes:
      '[{"size":"As","quantity":"50","price":"1","cost":224.00000000000003,"id":"50414854-a943-468f-a8dc-9c0f8b649c01","sortId":1},{"size":"M","quantity":"12","price":"1","cost":63,"id":"b694e4fe-2355-40b1-beeb-9bc8a2e07849","sortId":2}]',
    productUrl: null,
    productImage: "",
    isCommission: null,
    isCommissionType: null,
    isCommissionValue: null,
    isCommissionTotal: null,
    hasName: null,
    hasNumbers: null,
    teamName: null,
    packagedBy: null,
    totalQuantity: 62,
    totalPrice: 62,
    notes: "",
    isReady: false,
    lotImagePath: null,
    approveStatus: "approved",
    approvedTime: "2025-11-28",
    approvalComments: null,
    createdAt: "2024-05-09T14:47:34.000Z",
    updatedAt: "2025-11-28T09:48:08.000Z",
    productTypes: {
      id: 6,
      companyId: 3,
      productTypeId: 4,
      sortId: 3,
      productTypes: "Sublimation -nn",
      showOnJobBoard: true,
      createdAt: "2023-03-22T10:00:03.000Z",
      updatedAt: "2025-11-06T16:29:26.000Z",
    },
  },
  {
    approvalColors: [],
    id: 126,
    companyId: 3,
    WOId: 103,
    userId: 5,
    sortId: 6,
    productTypeId: 1,
    productType: "Screen Printing",
    productStyle: "test",
    productColor: "test",
    productDescription: "test",
    productFabric: "test",
    productSizes:
      '[{"size":"s","quantity":"12","price":"5","cost":49.44,"id":"8c8b99af-6d40-48db-88e9-5ccbe15f9d17","sortId":1}]',
    productUrl: null,
    productImage: null,
    isCommission: null,
    isCommissionType: null,
    isCommissionValue: null,
    isCommissionTotal: null,
    hasName: null,
    hasNumbers: null,
    teamName: null,
    packagedBy: null,
    totalQuantity: 12,
    totalPrice: 60,
    notes: "",
    isReady: false,
    lotImagePath: null,
    approveStatus: "pending",
    approvedTime: "2025-11-28",
    approvalComments: null,
    createdAt: "2024-05-09T14:47:34.000Z",
    updatedAt: "2025-11-28T09:48:08.000Z",
    productTypes: {
      id: 3,
      companyId: 3,
      productTypeId: 1,
      sortId: 4,
      productTypes: "Screen Printing",
      showOnJobBoard: true,
      createdAt: "2023-03-22T09:52:34.000Z",
      updatedAt: "2023-03-27T07:33:03.000Z",
    },
  },
  {
    approvalColors: [],
    id: 150,
    companyId: 3,
    WOId: 103,
    userId: 5,
    sortId: 7,
    productTypeId: 4,
    productType: "Sublimation",
    productStyle: "JSK-21321",
    productColor: "YELLOW",
    productDescription: "JERSEY",
    productFabric: "asdas",
    productSizes:
      '[{"size":"XS","quantity":"7","price":"3","cost":150.5,"id":"35fbf4c8-033a-4eee-98bd-ed308fa69568","sortId":1},{"size":"S","quantity":"3","price":"3","cost":60,"id":"91a1647c-3e1a-47f9-9a97-5d4821626492","sortId":2},{"size":"M","quantity":"8","price":"3","cost":52,"id":"5c32adf5-ec0a-4b47-905d-30b136ba0a1a","sortId":3},{"size":"l","quantity":"8","price":"3","cost":52,"id":"e9757ae9-f183-4cb9-948e-e43de00eb592","sortId":4},{"size":"XL","quantity":"8","price":"3","cost":180,"id":"68b3dc7f-bc56-4163-ab3d-bbec6e3b855d","sortId":5}]',
    productUrl: null,
    productImage: "",
    isCommission: null,
    isCommissionType: null,
    isCommissionValue: null,
    isCommissionTotal: null,
    hasName: null,
    hasNumbers: null,
    teamName: null,
    packagedBy: null,
    totalQuantity: 34,
    totalPrice: 102,
    notes: "<p>aasdasd</p>",
    isReady: false,
    lotImagePath: null,
    approveStatus: "pending",
    approvedTime: "2025-11-28",
    approvalComments: null,
    createdAt: "2025-04-16T14:27:28.000Z",
    updatedAt: "2025-11-28T09:48:08.000Z",
    productTypes: {
      id: 6,
      companyId: 3,
      productTypeId: 4,
      sortId: 3,
      productTypes: "Sublimation -nn",
      showOnJobBoard: true,
      createdAt: "2023-03-22T10:00:03.000Z",
      updatedAt: "2025-11-06T16:29:26.000Z",
    },
  },
];

let locationLogo =
  "https://kms.nyc3.digitaloceanspaces.com/kms/companyLogos/3/locationLogo/pdfLogo/krown.png?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Credential=DO00GKGBNPLH36ZMAXR3%2F20251226%2Fus-east-1%2Fs3%2Faws4_request&X-Amz-Date=20251226T062832Z&X-Amz-Expires=900&X-Amz-Signature=e69689362f0d226f52a09e16b0d5849d9dd83db6b856ec13a1d332afaba4ebaa&X-Amz-SignedHeaders=host&x-id=GetObject";

function WorkOrdersPdf() {
  const [locationLogo, setLocationLogo] = useState(null);
  const [showPdf, setShowPdf] = useState(false);
  const [groupedProductList, setGroupedProductList] = useState(null);

  const getLocationLogo = async () => {
    const { data } = await API.post(
      "/design-request/get-image",
      { path: selectedQuote?.location?.pdfLogo },
      {
        headers: authHeader(),
      }
    );
    setLocationLogo(data);
    setShowPdf(true);
    return data;
  };

  const getGroupedProducts = (list) => {
    let productListObj = JSON.parse(list);
    let groupedProduct = productListObj.reduce((acc, product) => {
      acc[product?.productType] = [
        ...(acc[product?.productType] || []),
        product,
      ];
      return acc;
    }, {});
    return groupedProduct;
  };

  useEffect(() => {
    if (selectedQuote?.location?.pdfLogo) {
      getLocationLogo();
    } else {
      setShowPdf(true);
    }
  }, [selectedQuote]);

  useEffect(() => {
    let groupedProducts = getGroupedProducts(JSON.stringify(data));
    setGroupedProductList(groupedProducts);
  }, [data]);

  useEffect(() => {
    if (pdfProducts) {
      // console.log("productsList", productsList);
      // let groupedByStyle = pdfProducts.reduce((acc, product) => {
      //   if (!acc[product.productStyle]) {
      //     acc[product.productStyle] = [];
      //   }
      //   acc[product.productStyle].push(product);
      //   return acc;
      // }, {});
      // // console.log("groupedByStyle", groupedByStyle);
      // let processedProducts = [];
      // Object.keys(groupedByStyle).forEach((style) => {
      //   let productsForStyle = groupedByStyle[style];
      //   let combinedSizes = {};
      //   // Go through each product and parse sizes
      //   productsForStyle.forEach((product) => {
      //     let sizes = JSON.parse(product.productSizes);
      //     sizes.forEach((sizeObj) => {
      //       if (combinedSizes[sizeObj.size]) {
      //         combinedSizes[sizeObj.size].quantity += parseInt(
      //           sizeObj.quantity
      //         );
      //         combinedSizes[sizeObj.size].cost += parseFloat(sizeObj.cost);
      //       } else {
      //         combinedSizes[sizeObj.size] = {
      //           ...sizeObj,
      //           quantity: parseInt(sizeObj.quantity),
      //           cost: parseFloat(sizeObj.cost),
      //         };
      //       }
      //     });
      //   });
      //   // Convert combinedSizes back to array
      //   let combinedSizesArray = Object.keys(combinedSizes).map((sizeKey) => ({
      //     size: sizeKey,
      //     quantity: combinedSizes[sizeKey].quantity,
      //     price: combinedSizes[sizeKey].price,
      //     cost: combinedSizes[sizeKey].cost,
      //     id: combinedSizes[sizeKey].id,
      //     sortId: combinedSizes[sizeKey].sortId,
      //   }));
      //   // Create a new product entry
      //   let newProductEntry = {
      //     ...productsForStyle[0], // Take other details from the first product
      //     productSizes: combinedSizesArray,
      //   };
      //   processedProducts.push(newProductEntry);
      // });
      // console.log("processedProducts", processedProducts);
    }
  }, [pdfProducts]);

  return (
    <div
      style={{
        top: 0,
        width: "calc(100vw - 250px)",
        marginLeft: 280,
      }}
    >
      <button
        id="open-custom-folder"
        data-path="2024"
        className="btn btn-success"
      >
        Open Folder
      </button>

      {/* ******************** Preview Cutting Pdf  ************************* */}
      <PDFViewer style={{ height: "90vh", width: "100%" }}>
        <WoCuttingPdf
          selectedWO={selectedWO}
          productsList={pdfProducts}
          locationLogo={locationLogo}
          showInvoicePage={false}
          showContactAndShipping={true}
        />
      </PDFViewer>

      {/*   Grouped Product
       ********************************************* */}
      {/* {showPdf && (
        <PDFViewer style={{ height: "90vh", width: "100%" }}>
          <ProductPdf
            productList={groupedProductList}
            allProdList={data}
            selectedWorkOrder={selectedWO}
            locationLogo={locationLogo}
            showInvoicePage={false}
            isTeamView={true}
          />
        </PDFViewer>
      )} */}
      {/*   WO Pdf ALL
       ********************************************* */}
      {/* {locationLogo && (
        <PDFViewer style={{ height: "90vh", width: "100%" }}>
          <WOPdf
            selectedWO={selectedWO}
            productsList={selectedWO?.WOProducts}
            locationLogo={locationLogo}
            showInvoicePage={false}
          />
        </PDFViewer>
      )} */}

      {/*   Loss Run Pdf
       ********************************************* */}
      {/* <PDFViewer style={{ height: "90vh", width: "100%" }}>
        <LossRunReportPdf
          reportData={{
            id: 3,
            companyId: 3,
            lossId: 3,
            description: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Error, voluptatum eos. Quidem pariatur inventore rerum aliquid molestiae ipsum non accusantium, minima voluptate odit facilis officia id in repellat quos totam!
Commodi, optio accusamus, libero molestiae modi officia ut deserunt odio cumque quod placeat consequatur facilis porro maiores, fuga dignissimos dolorum ipsam at consectetur tempora cupiditate neque illum? Harum, modi quisquam.
Unde fuga nostrum odit, nobis modi provident voluptate iusto reprehenderit quam. Sequi labore aspernatur, necessitatibus veritatis nulla autem aliquid sunt magni sint inventore, excepturi ullam esse officia consequuntur qui maiores.
Id vero corrupti omnis natus temporibus. Culpa at quasi dolor doloribus ea labore quibusdam totam, nesciunt cumque, possimus inventore. Magni consequatur dicta dignissimos. Corrupti eligendi quisquam repudiandae consequatur officia velit?
Neque adipisci quam fugit, itaque amet maiores recusandae ratione voluptates, tempore nobis magni repellendus soluta sit vitae velit! Recusandae iusto sed dolorem laboriosam pariatur inventore quia sapiente sit autem perspiciatis!`,
            byEmployee: "Abdur Rehman",
            department: "Sublimation",
            amount: 5000,
            printDate: null,
            createdAt: "2025-09-23T06:21:50.000Z",
            updatedAt: "2025-09-23T06:21:50.000Z",
          }}
        />
      </PDFViewer> */}

      {/*   WO Pdf ALL
       ********************************************* */}
      {/* {locationLogo && (
        <PDFViewer style={{ height: "90vh", width: "100%" }}>
          {selectedReport && (
            <AttendanceReport selectedReport={selectedReport} />
          )}
        </PDFViewer>
      )} */}
      {/*   Quote Pdf
       ********************************************* */}
      {/* {locationLogo && (
        <PDFViewer style={{ height: "90vh", width: "100%" }}>
          <QuotePdf
            selectedQuote={selectedQuote}
            productsList={selectedQuote?.quoteProducts}
            locationLogo={locationLogo}
            showTotal={true}
          />
        </PDFViewer>
      )} */}

      {/*   Team View Pdf
       ********************************************* */}
      {/* {locationLogo && (
        <PDFViewer style={{ height: "90vh", width: "100%" }}>
          <TeamViewPdf
            selectedWO={selectedWO}
            productsList={selectedWO?.WOProducts}
            locationLogo={locationLogo}
            showInvoicePage={false}
          />
        </PDFViewer>
      )} */}
      {/* {data && (
        <PDFDownloadLink
          document={
            <MyDocument
              productList={JSON.stringify(data)}
              selectedWO={selectedWO}
            />
          }
          fileName="testPdf"
        >
          <button className="btn btn-primary">Download</button>
        </PDFDownloadLink>
      )} */}
    </div>
  );
}

export default WorkOrdersPdf;
